import React from 'react';
import { Col, Row, Card, CardBody, CardTitle, CardText } from 'reactstrap';
import './exames.styles.css';

const ExamesMacroscopiaPage = (props) => (
    <div>
        {
            props.examesemaberto.length > 0 && <div style={{ overflowY: 'scroll', overflowX: 'hidden', maxHeight: '600px', paddingRight: '10px' }}>
                {
                    props.examesemaberto.map(item => {
                        return (<Row key={item.id} className="mv-exame-macro-container">
                            <Col>
                                <Card>
                                    <Row>
                                        <Col sm={'auto'}>
                                            <CardBody className="pb5">
                                                <CardTitle>{`Exame ${item.numeroExame} | Laudo ${item.laudo}`}</CardTitle>
                                                <CardText>{`${item.exame} - solicitado por ${item.medicoSolicitante}`}</CardText>
                                            </CardBody>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <CardBody className="pt0">
                                                <table>
                                                    <tbody>
                                                        {
                                                            item.etapas !== undefined && item.etapas.filter((item) => {
                                                                return item.status !== 'naorealizado';
                                                            }).map((etapa, i) => {
                                                                const executante = etapa.medicoEtapa !== ''
                                                                    ? ` executada por ${etapa.medicoEtapa}`
                                                                    : ' executada';
                                                                const data = etapa.dataEtapa !== ''
                                                                    ? ` em ${etapa.dataEtapa}`
                                                                    : '';
                                                                return (
                                                                    <tr key={i}>
                                                                        <td>Etapa <strong>{etapa.etapa}</strong>  </td>
                                                                        <td>{`${executante}${data}`}</td>
                                                                    </tr>
                                                                )
                                                            })
                                                        }
                                                    </tbody>
                                                </table>
                                            </CardBody>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>)
                    })
                }
            </div>
        }
    </div>
)

export default ExamesMacroscopiaPage;


// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/macroscopia/operacoes/exames/exames.page.js